import { countryCodes } from "../countryCodes";

export function parsePhoneNumber(number) {
  if (!number) {
    return {
      countryCode: null,
      areaCode: null,
      phoneNumber: null,
      isoCode: "us",
    };
  }

  if (number.startsWith("+")) {
    number = number.slice(1, number.length);
  }

  number = number
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll(" ", "")
    .replaceAll("-", "");

  const minCountryCodeLength = 1;
  const maxCountryCodeLength = 4;

  for (let i = maxCountryCodeLength; i >= minCountryCodeLength; i--) {
    let countryCode = number.slice(0, i);

    if (countryCode.length < i) {
      // number is not long enough to consider this length as a country code
      continue;
    }

    let isoCode = countryCodes[countryCode];

    // last char to check, if it's 1 it means the area code isn't valid
    // let's assume it's a us number
    if (i === 1 && countryCode === "1") {
      countryCode = number.slice(0, 4);
      isoCode = "US";
    }

    if (isoCode) {
      let areaCode;

      if (countryCode.startsWith("1")) {
        areaCode = countryCode.slice(1, 4);
        countryCode = "1";
      } else {
        areaCode = number.slice(i, i + 3);
      }

      return {
        countryCode,
        areaCode,
        phoneNumber: number.slice(
          countryCode.length + areaCode.length,
          number.length,
        ),
        isoCode,
      };
    }
  }

  return {
    countryCode: null,
    areaCode: null,
    phoneNumber: null,
    isoCode: "us",
  };
}

export function formatPhoneNumber(num, extension) {
  if (!num) {
    return "";
  }

  const parsed = parsePhoneNumber(num);
  const { countryCode, areaCode, phoneNumber } = parsed;

  if (!countryCode || !areaCode || !phoneNumber) {
    return num;
  }

  return `+${countryCode} (${areaCode})-${phoneNumber.slice(
    0,
    3,
  )}-${phoneNumber.slice(3, phoneNumber.length)}${
    extension ? `;${extension}` : ""
  }`;
}
